<script setup lang="ts">
import FooterCheckout from '@consumer/modules/v2/layout/FooterCheckout.vue'
import FooterDefault from '@consumer/modules/v2/layout/FooterDefault.vue'
import FooterSimple from '@consumer/modules/v2/layout/FooterSimple.vue'
import FooterCardManagement from './FooterCardManagement.vue'

defineProps<{
  type?: 'default' | 'simple' | 'checkout' | 'card_manage'
}>()
</script>

<template>
  <footer id="v2-footer" class="w-full bg-white flex flex-col">
    <div class="v2-footer-content">
      <FooterSimple v-if="type === 'simple'"/>
      <FooterCheckout v-else-if="type === 'checkout'"/>
      <FooterCardManagement v-else-if="type === 'card_manage'"/>
      <FooterDefault v-else/>
    </div>
    <div class="v2-footer-print" hidden>
      <FooterCheckout/>
    </div>
  </footer>
</template>

<style scoped>
@media print {
  .v2-footer-content {
    display: none;
  }

  .v2-footer-print {
    display: block !important;
  }
}
</style>
